import DOMPurify from "isomorphic-dompurify";
import { useState } from "react";
import Button from "~/components/lib/Button";
import Text from "~/components/lib/Text";
import type { BlogComment } from "~/entities/blog/types";
import { formatDate } from "~/utils/date";
import CommentForm from "./CommentForm";

type Props = {
  comment: BlogComment;
};

const Comment: React.FC<Props> = ({ comment }) => {
  const [isReplying, setIsReplying] = useState(false);
  const formattedDate = formatDate(
    comment.createdAt.slice(0, 19),
    "MM/dd/yyyy hh:mm aaa",
  );

  return (
    <>
      <div className="blog-comments__comment">
        <Text
          element="p"
          className="blog-comments__info"
        >
          <b>{comment.name}</b>
          {formattedDate && (
            <Text
              element="span"
              className="blog-comments__date"
            >
              {formattedDate}
            </Text>
          )}
        </Text>
        <div
          className="blog-comments__body"
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(comment.body) }}
        />
        <Button
          variant="ghost"
          onClick={() => setIsReplying(!isReplying)}
          aria-expanded={isReplying}
          className="blog-comments__reply"
        >
          {isReplying ? "Hide" : "Reply"}
        </Button>
        {isReplying && <CommentForm parentId={comment.id} />}
      </div>
      {comment.replies.length > 0 && (
        <div className="blog-comments__replies">
          {comment.replies.map((reply) => (
            <Comment
              key={reply.id}
              comment={reply}
            />
          ))}
        </div>
      )}
    </>
  );
};

export default Comment;
